import Requester from "../helpers/Requester";
import App from "../layouts/app";
import { router } from "@inertiajs/react";
import TeamForm from "../components/TeamForm";
import PageTitle from "../components/PageTitle";
import ContentWrapper from "../components/ContentWrapper";

export default function TeamEdit({ team }: { team: any }) {

    const saveTeam = (data: any) => {
        const requester = new Requester();

        requester.post(requester.getUrl(`api/teams/${team.id}`), data).then((response) => {
            router.visit(`/admin/teams`);
        }).catch((error) => {
            alert("Error saving team: " + error.message);
        })
    }

    return (
        <App>
            <PageTitle title="Edit Team" />
            <ContentWrapper>
                <TeamForm onSubmit={saveTeam} team={team} />
            </ContentWrapper>
        </App >
    )
}